import React from "react";
import { Checkbox, FormGroup, FormControlLabel } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { FormContainer } from "components/ui/FormField/FormFieldContainer";
import Page from "components/ui/Page/Page";

const CarePathwayPrevent = ({
    options = [],
    selected = [],
    onChange,
    onSubmit,
    isSubmitting,
}) => {
    const handleChange = (optionValue) => {
        let newChecked = [];
        // If 'None of the above' is selected, uncheck all other options
        if (optionValue === "NONE" && !selected.includes(optionValue)) {
            newChecked = ["NONE"];
        }
        // Else handle other options
        else {
            newChecked = selected.includes(optionValue)
                ? selected.filter((value) => value !== optionValue)
                : [...selected, optionValue];
        }
        // set form state on change
        onChange("prevent", "preventOptions", newChecked, "checkbox");
    };

    return (
        <Page
            heading="Care Pathway"
            subHeading="This information will help us customize your experience."
        >
            <FormContainer
                heading="Just one more question! Do any of the following apply to you?"
                subHeading="Select all that apply."
                sx={{
                    width: "65%",
                }}
            >
                <FormGroup>
                    {options.map((option) => (
                        <FormControlLabel
                            key={option.value}
                            control={
                                <Checkbox
                                    // Disable all other options if 'None of the above' is selected
                                    disabled={
                                        selected.includes("NONE") && option.value !== "NONE"
                                    }
                                    checked={selected.includes(option.value)}
                                    onChange={() => handleChange(option.value)}
                                />
                            }
                            label={option.label}
                        />
                    ))}
                </FormGroup>
                <LoadingButton
                    variant="outlined"
                    onClick={onSubmit}
                    loading={isSubmitting}
                    sx={{ mt: 3 }}
                    disabled={!selected.length}
                >
                    NEXT
                </LoadingButton>
            </FormContainer>
        </Page>
    );
};

export default CarePathwayPrevent;
